var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profil-container"},[_c('h3',{staticClass:"profil-title"},[_vm._v("Halaman Pengisian Data Vendor")]),_c('p',{staticClass:"profil-subtitle"},[_vm._v("Silahkan mengisi data sesuai kolom di bawah")]),_c('div',{staticClass:"vendor-form-wrapper"},[_c('input-doc',{attrs:{"label":'Perizinan',"modelName":'addedPerizinan',"isRequired":false,"mutationName":'k3lStore/SET_K3L_FORM',"storeName":'k3lStore',"modalName":'modal_add_perizinan',"disabled":true}}),_c('input-select-table',{attrs:{"label":'Bidang Usaha Pertambangan Inti',"tables":[
      {
        name: 'Jenis',
        obj_name: 'jenis',
        css: 'column10 mr10',
      },
      {
        name: 'Bidang',
        obj_name: 'bidang',
        css: 'column40',
      },
      {
        name: 'Sub Bidang',
        obj_name: 'sub_bidang',
        css: 'column40',
      } ],"modelName":'addedIUJP',"isRequired":false,"mutationName":'k3lStore/SET_K3L_FORM',"storeName":'k3lStore',"modalName":'modal_add_iujp',"disabled":true}}),_c('input-fill-form',{attrs:{"label":'Bidang Usaha Pertambangan Non Inti',"tables":[
      {
        name: 'Bidang',
        obj_name: 'desc',
        css: 'column30 mr10 all-column',
        input: false,
        type: '',
      },
      {
        name: 'Penjelasan',
        obj_name: 'penjelasan',
        css: 'column70',
        input: true,
        type: 'text',
      } ],"isRequired":false,"modalName":'modal_add_iujp_non_inti',"modelName":'addedIUJPnonInti',"mutationName":'k3lStore/SET_K3L_FORM',"storeName":'k3lStore',"disabled":_vm.$store.state.k3lStore.is_sipm_approved}}),_c('input-upload',{attrs:{"label":'Lampiran dokument Struktur Organisasi Perusahaan (Posisi/Jabatan & Nama Pekerja)',"modelName":'structurOrgFile',"isRequired":false,"mutationName":'k3lStore/SET_K3L_FORM',"storeName":'k3lStore',"docId":1,"is_single":true,"disabled":_vm.$store.state.k3lStore.is_sipm_approved}}),_c('input-fill-form',{attrs:{"label":'Isi tabel daftar karyawan yang memiliki sertifikat kompetensi K3 dan atau kompetensi khusus sesuai jabatan dan bidangnya',"tables":[
  {
    name: 'Posisi',
    obj_name: 'posisi',
    css: 'column20',
    input: false,
    type: '',
  },
  {
    name: 'Jumlah Karyawan',
    obj_name: 'jumlah',
    css: 'column20 mr10 all-column',
    input: false,
    type: '',
  },
  {
    name: 'Kompetensi Umum / Khusus',
    obj_name: 'umum_khusus',
    css: 'column20 mr10 all-column',
    input: false,
    type: '',
  },
  {
    name: 'Pengalaman Kerja (Tahun)',
    obj_name: 'pengalaman_kerja',
    css: 'column20 mr10 all-column',
    input: false,
    type: '',
  },
  {
    name: 'Dokumen Pendukung',
    obj_name: 'sertifikat_karyawan',
    css: 'column20 mr10 all-column',
    input: false,
    type: 'file',
  } ],"modelName":'addedCompetencies',"isRequired":false,"mutationName":'k3lStore/SET_K3L_FORM',"storeName":'k3lStore',"modalName":'modal_add_competencies',"operationAdd":'skill_add',"editMutation":'k3lStore/SET_SERTIFIKAT_KARYAWAN',"disabled":_vm.$store.state.k3lStore.is_sipm_approved}}),_c('notes',{attrs:{"items":[
      '<strong>*Catatan</strong>',
      '1. <strong>Kompetensi Umum -</strong> Sertifikasi pekerjaan yang membutuhkan pelatihan dan penguasaan terhadap suatu pengetahuan/keahlian umum yang tidak berdampak kepada kejadian LTI & fatality.',
      '2. Contoh Dokumen Pendukung/Sertifikasi <strong>Kompetensi Umum</strong> K3 (AK3 Umum/POP) - AK3 Umum/POP/ISM Code/sertifikat K3 lainnya.',
      '3. <strong>Kompetensi Khusus -</strong> Sertifikasi pekerjaan yang membutuhkan pelatihan dan penguasaan terhadap suatu pengetahuan/keahlian khusus yang dapat berdampak kepada kejadian LTI & fatality.',
      '4. Contoh Dokumen Pendukung/Sertifikasi <strong>Kompetensi Khusus</strong> (POP/POU) sesuai bidang kerja - Welder, SIO alat angkat, SIO riger, Scafolder, AK3 Listrik, KIM, dll.',
      '5. <strong>Pengalaman Kerja -</strong> Penjelasan Umum Pengalaman Kerja Sebelumnya, Rata-rata Jumlah Tahun Pengalaman' ]}})],1),_c('div',{staticClass:"profil-btn-wrapper"},[_c('div',{staticClass:"btn-landing",on:{"click":function($event){return _vm.goBack()}}},[_vm._v("Kembali")]),_c('div',{staticClass:"btn-landing",attrs:{"href":""},on:{"click":function($event){return _vm.goNext()}}},[_vm._v(" Simpan dan Lanjutkan ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }